import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
export const MultipleCard = ({
  CARDID = "",
  Stock = "",   
  onClick = () => {},
}) => {
  let xsLabel = 4;
  let xsColon = 0.2;
  let xsValue = 7.8;

  let mdLabel = 3;
  let mdColon = 0.5;
  let mdValue = 8.5;
 
  return (
    <Grid
      container
      spacing={0}
      rowSpacing={0}
      sx={{
        // border: "1px solid black",
        borderWidth: "1px 1px 1px 5px",
        borderStyle: "solid solid solid solid",
        borderRadius: "0px 10px 10px 0px",
        padding: "12px 8px",
        marginTop: "5px",
        borderColor: "#0d73bb",

        // border-width: 1px 1px 1px 3px;
        // border-style: double double double solid;
      }}
      columns={{ xs: 12, sm: 12, md: 12 }}
      onClick={onClick}
      className="PickingHeadCard"
    >
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"CARDID"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={" : "} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue} >
        <CmpTypographyField xcomponent={"span"} xText={CARDID} />
      </Grid>
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Stock"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={" : "} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={Stock} />
      </Grid>
    </Grid>
  );
};
